<ng-template #triggerOverlay="rtConnectedOverlay" rt-connected-overlay>
  <div
    #overlayTriggerOrigin="rtOverlayOrigin"
    rt-overlay-origin
    (keydown)="onKeyDown($event)"
    (blur)="onTouched()"
    [attr.tabindex]="0"
    class="focusable"
    layout-full-width
  >
    <ng-template
      [ngTemplateOutlet]="selectTemplatesService.triggerDirective.templateRef"
      [ngTemplateOutletContext]="{ $implicit: selectController, inOverlay: true }"
    />
  </div>
</ng-template>

<div
  #inlineTriggerOrigin="rtOverlayOrigin"
  rt-overlay-origin
  (keydown)="onKeyDown($event)"
  (blur)="onTouched()"
  [attr.tabindex]="0"
  class="focusable"
>
  <ng-template
    [ngTemplateOutlet]="selectTemplatesService.triggerDirective.templateRef"
    [ngTemplateOutletContext]="{ $implicit: selectController, inOverlay: false }"
  />
</div>

<ng-template #dropdownTemplate #dropdownConnectedOverlay="rtConnectedOverlay" rt-connected-overlay>
  <rt-dropdown
    [width]="DropdownWidth.FullWidth"
    (keydown)="onKeyDown($event)"
    [attr.tabindex]="0"
    class="focusable"
  >
    @for (item of selectTemplatesService.headerTemplates; track item.template) {
      <ng-container [ngTemplateOutlet]="item.template" />
    }
    @if (itemsLoading) {
      <rt-spinner />
    } @else if (selectItemsService.itemsToRender().length) {
      <virtual-scroller
        #virtual
        [bufferAmount]="20"
        [scrollAnimationTime]="0"
        [scrollThrottlingTime]="10"
        [enableUnequalChildrenSizes]="true"
        [executeRefreshOutsideAngularZone]="true"
        [compareItems]="vsCompareItems || vsCompareItemsFallback"
        [items]="selectItemsService.itemsToRender()"
        (vsChange)="onVirtualScrollUpdate($event)"
        (vsEnd)="onVsEnd($event)"
        [ngStyle]="virtualScrollStyle"
      >
        @for (item of virtual.viewPortItems; track item.value) {
          <rt-select-item-wrapper
            [templateOutlet]="selectTemplatesService.listItemDirective.templateRef"
            [templateOutletContext]="{
              $implicit: selectController,
              index: $index + virtualScrollIndexOffset,
              isHoverState: selectController.isHovered($index + virtualScrollIndexOffset),
              isLast: $last,
              item,
            }"
          />
        }
      </virtual-scroller>
    } @else {
      <ng-container [ngTemplateOutlet]="selectTemplatesService.emptyStateTemplate" />
    }
    @for (item of selectTemplatesService.footerTemplates; track item.template) {
      <ng-container [ngTemplateOutlet]="item.template" />
    }
  </rt-dropdown>
</ng-template>
